import dayjs from 'dayjs'
import i18n from '@/locales/index'
export default [
  {
    type: 'datepicker',
    placeholder: '',
    filed: 'daterange',
    label: '',
    pickerType: 'datetimerange',
    valueFormat: 'yyyy-MM-dd HH:mm',
    format: 'yyyy-MM-dd HH:mm',
    default: [
      dayjs()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm'),
      dayjs().format('YYYY-MM-DD HH:mm')
    ]
  },
  {
    type: 'select',
    placeholder: i18n.t('Device.action'),
    filed: 'state',
    default: '',
    options: [
      {
        name: i18n.t('Device.toOnline'),
        code: true
      },
      {
        name: i18n.t('Device.toOffline'),
        code: false
      }
    ]
  }
]
